export default {
  GET_ALL: `#graphql
  query getFraudReports($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getFraudReports(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init: $init, final: $final) {
      docs {
        _id
        number
        code
        brand
        trigger
        triggeredBy
        status
        windowFrom
        windowTo
        ordersAnalyzed
        ordersFlagged
        model
        batches
        durationMs
        error
        finishedAt
        findings {
          order
          assessment
          confidence
          reason
          evidence
          relatedOrders
          caseCode
          name
          phone
          email
          address
          location
          total
          methodPay
          status
          pays {
            methodPay
            lastFour
            value
            state
            error
          }
          fraudConfirmedCount
          createdAt
          paidAt
        }
        createdAt
        updatedAt
      }
      totalDocs
      limit
      hasPrevPage
      hasNextPage
      page
      totalPages
      prevPage
      nextPage
      pagingCounter
    }
  }`,

  GET_ONE: `#graphql
  query getFraudReport($number: Int!) {
    getFraudReport(number: $number) {
      _id
      number
      code
      brand
      trigger
      triggeredBy
      status
      windowFrom
      windowTo
      ordersAnalyzed
      ordersFlagged
      model
      batches
      durationMs
      error
      finishedAt
      findings {
        order
        assessment
        confidence
        reason
        evidence
        relatedOrders
        caseCode
        name
        phone
        email
        address
        location
        total
        methodPay
        status
        pays {
          methodPay
          lastFour
          value
          state
          error
        }
        fraudConfirmedCount
        createdAt
        paidAt
      }
      createdAt
      updatedAt
    }
  }`,

  RUN: `#graphql
  mutation runFraudReport {
    runFraudReport {
      _id
      number
      code
      status
      trigger
      triggeredBy
      ordersAnalyzed
      ordersFlagged
      createdAt
    }
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/fraudReport.js